import React, { useState, useEffect } from "react";
import { Flex } from "antd";
import { getShortSID, formatDate, formatDateWithTime } from "../../../Components/utility";
import moment from "moment";
import * as configApi from "../../../config/configApi.js";

const PatientInfo = ({ t, patientInfo }) => {
  const [orderInfo, setOrderInfo] = useState({});

  useEffect(() => {
    if (patientInfo?.listOrder?.length > 0) {
      setOrderInfo(patientInfo.listOrder[0]);
    }
  }, [patientInfo]);

  const {
    patientId,
    sampleId,
    patientName,
    age,
    sex,
    urgent,
    bed,
  } = patientInfo || {};

  const sexLabel =
    sex === "M" ? t("Male") : sex === "F" ? t("Female") : "";

  const infoItems = [
    patientId ? `PID: ${patientId}` : "",
    sampleId,
    patientName,
    age,
    sexLabel,
    orderInfo.objectName,
    orderInfo.locationName && bed ? `${orderInfo.locationName} (${bed})` : orderInfo.locationName,
  ].filter(Boolean);

  return (
    <Flex className="w-100" align="center">
      <div style={{ 
            flex: 1, 
            paddingBottom:"5px",
            borderBottom:"1px solid #c7c7c7ff"
        }} className="text-truncate">
        <span
          style={{
            fontWeight: "bold",
            textTransform: "uppercase",
          }}
        >
          {t("INFORMATION PATIENT")}:
        </span>
        <span
          className="valid-requestInfo"
          style={{
            textTransform: "uppercase",
            color: urgent ? "#d92550" : configApi.USE_COLOR,
            fontWeight: "bold",
          }}
        >
          &nbsp;{infoItems.join(" | ")}
        </span>
      </div>
    </Flex>
  );
};

export default PatientInfo;
